import { Route } from "@mapmycustomers/shared/types/entity";

const getRouteCheckedStopCount = (route: Route): number =>
  route.stopTime?.reduce((sum, stop) => sum + (stop.checkedOff ? 1 : 0), 0) ?? 0;

export default getRouteCheckedStopCount;
